const moment = require("moment");

const dispatch = require("~/store.js").dispatch;
const server = require("~/server.js");
const events = require("./walkThruLoadEvents.js");

const walkThruLoadDispatchers = {
    LoadWalkThru(type, facNumber, guid) {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New(type, facNumber, guid);

            thunkDispatch(loading);

            const url = `audit/${type}/${facNumber}/${guid}/walk-thru`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const withAdjustedDate = Object.assign({}, json, {
                        Created: moment(json.Created).toDate()
                    });

                    const loaded = events.Loaded.New(withAdjustedDate);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);

                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = walkThruLoadDispatchers;


// WEBPACK FOOTER //
// ./src/events/walkThruLoad/walkThruLoadDispatchers.js